import React from 'react';
import { Icon, Menu } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import keycloak from '../../../keycloak';

function Logout() {
  const { t } = useTranslation();
  return (
    <Menu.Item as="a" key="logOutMenuItem" onClick={() => keycloak.logout()}>
      <Icon name="sign-out" />
      {t('header.log.out')}
    </Menu.Item>
  );
}

export default Logout;
